import React from 'react';
import { useTabsContext } from './tabs.provider';
import { ITabContent } from './tabs.types';

export const TabContent = ({ children, tabId }: ITabContent) => {
    const { selectedTabId } = useTabsContext();

    if (selectedTabId !== tabId) {
        return null;
    }

    return (
        <>
            {children}
        </>
    );
};
